import ApolloClient from 'apollo-boost';
// import { message } from 'antd';

const client = new ApolloClient({
  uri: process.env.GRAPHQL_ENDPOINT,
  credentials: 'include',
  onError: ({ graphQLErrors, networkError, reponse }) => {
    // if (graphQLErrors) Response.errors = null;
    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations, path }) => {
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
      });
    }
    if (networkError) {
      console.log(`[Network error]: ${networkError}`);
      // message.error(`[Network error]: ${networkError}`);
    }
  }
});

export default client;
